import React, { useState } from "react";
import Table from "react-bootstrap/Table";
import Container from "react-bootstrap/Container";
import Assest from "../../assets/images/neel_kiara.jpg";
import Spinner from "react-bootstrap/Spinner";
import Badge from "react-bootstrap/Badge";
import Button from "react-bootstrap/Button";
import { ExistingLearner } from "../../molecules/existingLearner";

// const Button = styled.button`
//   color: #f64e60;
//   background-color: #ffe2e5;
//   border: none;
//   font-size: 14px;
//   border-radius: 10px;
//   padding: 7px 10px;
//   font-weight: bold;
//   &:hover {
//     color: white;
//     background-color: #f64e60;
//   }
// `;

export const ParentUpdate = (props) => {
  function getAge(dateString) {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }
  return (
    <Container className="my-3 bg-white rounded-3">
      <div className="d-flex flex-column flex-md-row p-3">
        <span className="text-bold fs-2">Learner Details</span>
        <ExistingLearner>
          <Button
            variant="secondary"
            className="ms-auto"
            title="Use learner code to add learner"
          >
            Add existing learner
          </Button>
        </ExistingLearner>
      </div>
      <Table responsive="md p-3">
        <thead>
          <tr>
            <th className="dashboard-blue fs-5">LEARNER</th>
            <th className="dashboard-blue fs-5">AGE</th>
            <th className="dashboard-blue fs-5">GENDER</th>
            {/* <th className="dashboard-blue">PROGRAMS NAME</th> */}
            {/* <th className="dashboard-blue">ACTION</th> */}
          </tr>
        </thead>
        <tbody>
          {props.loading ? (
            <tr>
              <td>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              </td>
            </tr>
          ) : props.error ? (
            <tr>
              <span className="text-danger">{props.error}</span>
            </tr>
          ) : (
            props.learners.map((l, index) => (
              <tr key={index}>
                <td className="w-20 align-middle">
                  <img className="w-20 rounded me-2" src={Assest} />
                  {l?.first_name + " " + l?.last_name}
                </td>
                <td className="align-middle">
                  {getAge(`${l?.date_of_birth}`)}
                </td>
                <td className="align-middle text-lowercase">
                  <Badge pill={true} bg="secondary">
                    {l?.gender}
                  </Badge>
                </td>
                {/* <td className="align-middle">
                  <Button variant="danger">
                    <FontAwesomeIcon className="text-light" icon={faTrash} />
                  </Button>
                </td> */}
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </Container>
  );
};
